import React from 'react';

export default ({ children, title }) => (
    <div className="gallery-photo-video-embed">
        <h3 class="border-bottom-custom">{title}</h3>
        <div className="gallery-bg-dark">                
                <div className="it-carousel-wrapper w-100">
                    <div className="it-carousel-all it-img-card">
                        {children}
                    </div>
                </div>
            
        </div>
    </div>
);
